import React, { useCallback } from 'react';
import { useGridFilter } from 'ag-grid-react';
import { Select, MenuItem, Checkbox, ListItemText, Typography, Divider, FormGroup, FormControlLabel } from '@mui/material';

// Notice: No 'params' here. We destructure the new top-level props.
const ColFilter = ({ model, onModelChange, getValue, api, column }) => {
  const columnId = column.colId;
  const headerName = api.getDisplayNameForColumn(column, 'header');
  let options = [];
  if(columnId === "Platform")
    options = ['Web', 'Shopee', 'Lazada'];
  else if(columnId === "Status")
    options = ['Web Orders', 'Requested', 'Issued', 'Canceled'];
  else if(columnId === "OrderStatus")
    options = ['Chưa xử lý', 'Đang xử lý', 'Hủy đơn', 'Xác nhận', 'Hoàn tất'];
  else if(columnId === "WarehouseStatus")
    options = ['Chưa xử lý', 'Đã giao', 'Hủy'];
  else if(columnId === "DeliStatus")
    options = ['Chưa xử lý', 'Giao thành công'];
  else if(columnId === "ReturnStatus")
    options = ['', 'Khách hàng trả hàng', 'Kho đã nhận hàng'];

  const doesFilterPass = useCallback((node) => {
    const cellValue = getValue(node);
    // If model is null, filter is inactive
    if (!model || model.length === 0) return true;
    return model.includes(cellValue);
  }, [model, getValue]);

  // Register logic with the new hook
  useGridFilter({ doesFilterPass });

  const handleToggle = (value) => {
    const currentModel = model || [];
    const newModel = currentModel.includes(value)
      ? currentModel.filter((i) => i !== value) // Remove if already selected
      : [...currentModel, value]; // Add if not selected
    onModelChange(newModel.length === 0 ? null : newModel);
    // setTimeout(() => {
    //   api.hidePopupMenu();
    // }, 100);
  };

  return (
    <div style={{ padding: '12px', minWidth: '160px' }} onMouseDown={(e) => e.stopPropagation()}>
      <Typography variant="subtitle2" sx={{ fontStyle: 'italic', color: 'text.secondary', mb: 1 }}>
        Select {headerName}
      </Typography>
      <Divider sx={{ mb: 1 }} />
      
      <FormGroup>
        {options.map((status) => (
          <FormControlLabel
            key={status}
            control={
              <Checkbox
                size="small"
                checked={(model || []).includes(status)}
                onChange={() => handleToggle(status)}
              />
            }
            label={<Typography sx={{ fontSize: '0.9rem' }}>{status}</Typography>}
            sx={{ mb: 0.5 }}
          />
        ))}
      </FormGroup>
    </div>
  );
};
export default ColFilter;